"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissSummonedAbilityHandler = exports.DismissSummonedActorAbilityFactory = exports.DismissSummonedAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class DismissSummonedAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DismissSummoned;
        this.__typeName = "DismissSummoned";
    }
}
exports.DismissSummonedAbilityArgs = DismissSummonedAbilityArgs;
let DismissSummonedActorAbilityFactory = class DismissSummonedActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DismissSummoned", "OneEnemies", 1);
    }
};
DismissSummonedActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DismissSummoned")
], DismissSummonedActorAbilityFactory);
exports.DismissSummonedActorAbilityFactory = DismissSummonedActorAbilityFactory;
let DismissSummonedAbilityHandler = class DismissSummonedAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        if (container.getLevel(selectedEnemy) > container.getLevel(ability.invokerId)) {
            container.applyFloatingText(sequence, ability.invokerId, "Target is too strong!", "red", "small");
            return;
        }
        const [summoned] = container.getEffectsOfType(selectedEnemy, EffectType_1.EffectType.Summoned);
        if (!summoned) {
            container.applyFloatingText(sequence, ability.invokerId, "Target wasn't summoned", "yellow", "small");
            return;
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.cancelEffect(sequence
                    .pushSequence("sequential")
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(summoned, "feet"), "MoonfireBeam")), summoned);
            }
        });
    }
};
DismissSummonedAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DismissSummoned)
], DismissSummonedAbilityHandler);
exports.DismissSummonedAbilityHandler = DismissSummonedAbilityHandler;
